import Icon from "@ews/react-icons";
import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonButtons, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonItem, IonModal, IonRow, IonTitle, IonToolbar } from "@ionic/react";
import { arrowDown, arrowUp, refresh } from "ionicons/icons";
import { useCallback, useEffect, useState } from "react";
import { deepCompare } from "../../utils";
import { useIsMobile } from "../Responsive";
import style from './FilterList.module.scss';
import { BooleanFilterType, Filter, FilterListProps, NumberFilterType, StingFilterType } from "./types";

export const stringFilter: StingFilterType = (a: string, b: string) => a.toLocaleLowerCase().includes(b.toLocaleLowerCase());
export const numberFilter: NumberFilterType = (a, b) => a >= b.from && a <= b.to;
export const booleanFilter: BooleanFilterType = (a: boolean, b: boolean) => a === b;


// const filterList = (list: any[], filter: Record<string, any>) =>
// {
//     const filtered = list.filter((data: Record<string, any>) =>
//     {
//         const checkList = [];

//         for (let key in data) {
//             if (!filter[key]) continue;
//             if (typeof filter[key] === 'function') {
//                 checkList.push(filter[key](data[key]));
//             }
//             else {
//                 checkList.push(false);
//                 throw new Error(`key: ${key} you forgot to give a filter function`);
//             };
//         }
//         return checkList.every((st) => st === true);
//     });

//     return filtered;
//};

export function isFilterActive<T extends Record<string | number | symbol, any>>(
    currentFilter: T,
    standardFilter: T,
    ignoreKeys: (keyof T)[] = []
)
{
    return !deepCompare<T>(currentFilter, standardFilter, ["guard", "isFilterOpen", "isDetailOpen", ...ignoreKeys]);
}


const MobileFilter: React.FC<Filter> = ({
    children,
    details,
    onReset,
    onIsOpen,
    isOpen = false
}) =>
{
    //const initialBreakpoint = 0.50;

    const { translate: t } = useL10n();

    function closeHandler()
    {
        onIsOpen && onIsOpen(false);
    }

    return <>
        <IonModal
            className={style.modal}
            isOpen={isOpen}
            initialBreakpoint={.5}
            showBackdrop={true}
            keepContentsMounted
            onDidDismiss={() => closeHandler()}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{t("[SID_MNU_HK_FILTER]")}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() =>
                        {
                            closeHandler();
                        }}>
                            <Icon icon={"close"} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <div
            //className="ion-padding"
            >
                {onReset && <IonButton
                    color={'danger'}
                    expand='full'
                    onClick={() =>
                    {
                        if (onReset) onReset(true);
                    }}
                >
                    {t("TPL_BEEZ3_RESET")}
                </IonButton>}
            </div>
            <IonContent
                className="ion-padding"
            >

                {/* <span style={{ display: "block", maxHeight: `${(currentBreakpoint * 100) - 7.72}vh` }}> */}
                <span>
                    {children}
                    {details}
                </span>
            </IonContent>
        </IonModal>
    </>;
};

const DesktopFilter: React.FC<Filter> = ({
    children,
    details,
    onReset,
    isDetailsOpen = false,
    showButton,
    onDetailOpen,
    isOpen
}) =>
{

    const [_isDetailsOpen, setDetailsOpen] = useState(isDetailsOpen);

    return <>
        {children ? <>
            <IonItem
                hidden={!isOpen}
                className={`filterList ${style.filterContainer}`}>
                <IonGrid>
                    <IonRow>
                        {children}
                        {showButton ? <IonCol
                            size="auto"
                        >
                            <div
                                className={style["fab-container"]}
                            >
                                {
                                    details ?
                                        <IonFab
                                            className={style["fab-inline"]}
                                        >
                                            <IonFabButton
                                                color="tertiary"
                                                size="small"
                                                onClick={() =>
                                                {
                                                    onDetailOpen && onDetailOpen(!_isDetailsOpen);
                                                    setDetailsOpen((state) => !state);
                                                }}
                                            >
                                                <IonIcon icon={_isDetailsOpen ? arrowUp : arrowDown}></IonIcon>
                                            </IonFabButton>
                                        </IonFab>
                                        :
                                        null
                                }
                                {onReset ? <IonFab
                                    className={style["fab-inline"]}>
                                    <IonFabButton
                                        color="tertiary"
                                        size="small"
                                        onClick={() =>
                                        {
                                            if (onReset) onReset(true);
                                        }}
                                    >
                                        <IonIcon icon={refresh}></IonIcon>
                                    </IonFabButton>
                                </IonFab> : null}
                            </div>
                        </IonCol>
                            : null}
                    </IonRow>
                </IonGrid>
            </IonItem>
        </>
            : null}
        {
            details ?
                <IonItem className={style.details} hidden={!(_isDetailsOpen && isOpen)}>
                    <IonGrid >
                        <IonRow>
                            {details}
                        </IonRow>
                    </IonGrid>
                </IonItem>
                : null
        }
    </>;
};

const FilterList: React.FC<FilterListProps> = ({
    children,
    isDetailsOpen = false,
    details,
    showButton = true,
    onReset,
    onDetailOpen,
    onIsOpen,
    isOpen = false,
    noPrint = false
}) =>
{
    const mobileView = useIsMobile();

    const detailOpenHandler = useCallback((status: boolean) =>
    {
        if (onDetailOpen) onDetailOpen(status);
    }, [onDetailOpen]);

    return <div className={`${noPrint ? style.noPrint : ""}`}>
        {
            mobileView ?
                <MobileFilter
                    onReset={onReset}
                    isDetailsOpen={isDetailsOpen}
                    onDetailOpen={detailOpenHandler}
                    onIsOpen={onIsOpen}
                    isOpen={isOpen}
                    details={details}
                    showButton={showButton}
                >
                    {children}
                </MobileFilter>
                :
                <DesktopFilter
                    showButton={showButton}
                    onDetailOpen={detailOpenHandler}
                    isDetailsOpen={isDetailsOpen}
                    isOpen={isOpen}
                    onReset={onReset}
                    details={details}
                >
                    {children}
                </DesktopFilter>
        }
    </div>;
};

export default FilterList;
